<template>
  <v-alert class="p-inline-alert" border="left" :color="color" dense dark>
    <v-btn
      aria-label="Close alert"
      class="p-inline-alert-close"
      icon="mdi-close"
      size="small"
      type="button"
      variant="text"
      @click="$emit('close')"
    />
    <div class="p-inline-alert-content">
      <slot></slot>
      <ol>
        <li v-for="message in messages" :key="message">
          {{ message }}
        </li>
      </ol>
    </div>
  </v-alert>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: 'red'
    },
    messages: {
      type: Array
    }
  }
}
</script>

<style scoped>
.p-inline-alert {
  position: relative;
}

.p-inline-alert-content {
  padding-right: 32px;
}

.p-inline-alert-close {
  color: white !important;
  height: 36px;
  min-width: 36px;
  position: absolute;
  right: 8px;
  top: 8px;
  width: 36px;
}
</style>
